import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Checkbox, Space, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { CustomRow, SaveButton, CancelButton } from './styledComponents';
import { SaveOutlined, CloseOutlined } from '@ant-design/icons';
import { AddUser } from '../../../../Redux/Actions/User';
import {
  DATE_FORMAT_OPTIONS,
  TIME_FORMAT_OPTIONS,
  DEFAULT_DATE_FORMAT,
  DEFAULT_TIME_FORMAT
} from '../../../../Constants/StringConstants';
import 'react-phone-input-2/lib/style.css';

const { Option } = Select;
const TranscriptionFlow = ({
  saveProfileInformation1,
  selectedItem,
  profile,
  getFacilities,
  facilities,
  edit,
  setEdit,
  saveLoading
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [user] = useSelector(state => [state.userReducer]);
  const [activateRoster, setActivateRoster] = useState();

  const isAdmin =
    user.userType === 'clinicAdmin' || user.userType === 'admin';

  const seededFormats = () => {
    const cfg = profile.dateTimeConfig || user.dateTimeConfig || {};
    return {
      dateFormat: cfg.dateFormat || DEFAULT_DATE_FORMAT,
      timeFormat: cfg.timeFormat || DEFAULT_TIME_FORMAT
    };
  };

  useEffect(() => {
    setActivateRoster(profile.activateRoster ? profile.activateRoster : false);
    form.setFieldsValue({
      ...profile,
      ...seededFormats()
    });
  }, [profile]);

  const onFormSubmit = values => {
    const { dateFormat, timeFormat, activateRoster: roster } = values;
    const dateTimeConfig = { dateFormat, timeFormat };

    // Update localStorage + Redux immediately so every date/time display reflects
    // the new format right away.
    const updatedUser = { ...user, dateTimeConfig };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    dispatch(AddUser(updatedUser));

    // Persist via PUT /clinic/user/config (handles loading / success / edit-exit).
    const payload = isAdmin
      ? { activateRoster: roster, dateTimeConfig }
      : { dateTimeConfig };
    saveProfileInformation1(payload);
  };

  const cancelEdit = () => {
    setEdit(false);
    form.resetFields();

    form.setFieldsValue({
      ...profile,
      ...seededFormats()
    });
  };

  return (
    <Form form={form} layout='vertical' onFinish={values => onFormSubmit(values)}>
      <Row justify='center'>
        <Col span={24}>
          <Form.Item label='Date Format' name='dateFormat'>
            <Select disabled={!edit} placeholder='Select date format'>
              {DATE_FORMAT_OPTIONS.map(opt => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label='Time Format' name='timeFormat'>
            <Select disabled={!edit} placeholder='Select time format'>
              {TIME_FORMAT_OPTIONS.map(opt => (
                <Option key={opt.value} value={opt.value}>
                  {opt.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {isAdmin && (
          <Col span={24}>
            <Form.Item
              label='Patient Roster Enabled'
              name='activateRoster'
              valuePropName='checked'
            >
              <Checkbox checked={activateRoster} disabled={!edit}>
                Enable Patient Roster
              </Checkbox>
            </Form.Item>
          </Col>
        )}
      </Row>

      <br />
      {edit === true && (
        <CustomRow justify='end'>
          <Space size={20}>
            <CancelButton onClick={cancelEdit} icon={<CloseOutlined />}>
              Cancel
            </CancelButton>

            <SaveButton
              type='primary'
              htmlType='submit'
              icon={<SaveOutlined />}
              loading={saveLoading}
            >
              Save
            </SaveButton>
          </Space>
        </CustomRow>
      )}
    </Form>
  );
};

export default TranscriptionFlow;
